"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var throttledFetch_1 = require("./throttledFetch");
var fetchHandler_1 = require("./fetchHandler");
var isRetriableStatus_1 = require("./isRetriableStatus");
var addFetchRetryHeaders_1 = require("./addFetchRetryHeaders");
var MAX_ATTEMPT = 2;
var TIMEOUT_ON_DISCONNECT = 5000;
var serviceResponseCallbackNumber = 0;
var createServiceResponseCallbacks = {};
// this returns a function that will unregister it
function registerCreateServiceResponseCallback(callback) {
    var id = serviceResponseCallbackNumber++;
    createServiceResponseCallbacks[id] = callback;
    return function () {
        delete createServiceResponseCallbacks[id];
    };
}
exports.registerCreateServiceResponseCallback = registerCreateServiceResponseCallback;
function fetchWithRetry(actionName, url, attemptCount, options) {
    var promise = throttledFetch_1.default(url, options);
    var callbackKeys = Object.keys(createServiceResponseCallbacks);
    for (var ii = 0; ii < callbackKeys.length; ii++) {
        createServiceResponseCallbacks[callbackKeys[ii]](promise, actionName, url, attemptCount, options);
    }
    return promise.then(function (response) {
        if (isRetriableStatus_1.default(response.status) && attemptCount < MAX_ATTEMPT) {
            addFetchRetryHeaders_1.default(++attemptCount, options.headers);
            return fetchWithRetry(actionName, url, attemptCount, options);
        }
        else {
            return fetchHandler_1.default(actionName, response, options);
        }
    }, function (error) {
        if (error.retriable && attemptCount < MAX_ATTEMPT) {
            return new Promise(function (resolve, reject) {
                setTimeout(function () {
                    try {
                        addFetchRetryHeaders_1.default(++attemptCount, options.headers);
                        resolve(fetchWithRetry(actionName, url, attemptCount, options));
                    }
                    catch (e) {
                        if (e.message) {
                            e.message = actionName + ":" + e.message;
                        }
                        reject(e);
                    }
                }, TIMEOUT_ON_DISCONNECT);
            });
        }
        else {
            throw error;
        }
    });
}
exports.default = fetchWithRetry;
